/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useRef } from 'react'

function useInterval (callback, delay) {

  const savedCallback = useRef()

  // Remember the latest callback.
  useEffect(() => {

    savedCallback.current = callback

  }, [callback])

  // Set up the interval.
  useEffect(() => {

    function tick () {

      // @ts-ignore
      savedCallback.current()

    }

    if (delay !== null) {

      const id = setInterval(tick, delay)
      return () => clearInterval(id)

    }

  }, [delay])

}

export default useInterval
